// Przekłady: kod (też nazwa katalogu w /data) i język, w którym wyświetlamy nazwy ksiąg.
export const BIBLES = {
  1: {code: 'EIB', language: 'pl'},
  2: {code: 'UBG', language: 'pl'},
  3: {code: 'BW', language: 'pl'},
  4: {code: 'BT', language: 'pl'},
  5: {code: 'KJV', language: 'en'},
  6: {code: 'ESV', language: 'en'},
  7: {code: 'NIV', language: 'en'},
  8: {code: 'NLT', language: 'en'},
  9: {code: 'MSG', language: 'en'},
  10: {code: 'BBE', language: 'en'}
}

// Liczba rozdziałów każdej księgi. Niektóre przekłady mają ich mniej (np. Ml w BT) – wtedy liczy się
// liczba wczytana z danych przekładu.
export const CHAPTERS = {
  1: 50, 2: 40, 3: 27, 4: 36, 5: 34, 6: 24, 7: 21, 8: 4, 9: 31, 10: 24,
  11: 22, 12: 25, 13: 29, 14: 36, 15: 10, 16: 13, 17: 10, 18: 42, 19: 150, 20: 31,
  21: 12, 22: 8, 23: 66, 24: 52, 25: 5, 26: 48, 27: 12, 28: 14, 29: 3, 30: 9,
  31: 1, 32: 4, 33: 7, 34: 3, 35: 3, 36: 3, 37: 2, 38: 14, 39: 4, 40: 28,
  41: 16, 42: 24, 43: 21, 44: 28, 45: 16, 46: 16, 47: 13, 48: 6, 49: 6, 50: 4,
  51: 4, 52: 5, 53: 3, 54: 6, 55: 4, 56: 3, 57: 1, 58: 13, 59: 5, 60: 5,
  61: 3, 62: 5, 63: 1, 64: 1, 65: 1, 66: 22
}

// Pełne nazwy ksiąg w kolejności kanonu, wyświetlane w języku przekładu.
export const NAMES = {
  pl: [
    'Rodzaju', 'Wyjścia', 'Kapłańska', 'Liczb', 'Powtórzonego Prawa', 'Jozuego', 'Sędziów', 'Rut', '1 Samuela',
    '2 Samuela', '1 Królewska', '2 Królewska', '1 Kronik', '2 Kronik', 'Ezdrasza', 'Nehemiasza', 'Estery',
    'Hioba', 'Psalmów', 'Przysłów', 'Kaznodziei', 'Pieśń nad pieśniami', 'Izajasza', 'Jeremiasza', 'Treny',
    'Ezechiela', 'Daniela', 'Ozeasza', 'Joela', 'Amosa', 'Abdiasza', 'Jonasza', 'Micheasza', 'Nahuma', 'Habakuka',
    'Sofoniasza', 'Aggeusza', 'Zachariasza', 'Malachiasza', 'Mateusza', 'Marka', 'Łukasza', 'Jana', 'Dzieje Apostolskie',
    'Rzymian', '1 Koryntian', '2 Koryntian', 'Galacjan', 'Efezjan', 'Filipian', 'Kolosan', '1 Tesaloniczan',
    '2 Tesaloniczan', '1 Tymoteusza', '2 Tymoteusza', 'Tytusa', 'Filemona', 'Hebrajczyków', 'Jakuba', '1 Piotra',
    '2 Piotra', '1 Jana', '2 Jana', '3 Jana', 'Judy', 'Objawienie'
  ],
  en: [
    'Genesis', 'Exodus', 'Leviticus', 'Numbers', 'Deuteronomy', 'Joshua', 'Judges', 'Ruth', '1 Samuel', '2 Samuel',
    '1 Kings', '2 Kings', '1 Chronicles', '2 Chronicles', 'Ezra', 'Nehemiah', 'Esther', 'Job', 'Psalms', 'Proverbs',
    'Ecclesiastes', 'Song of Songs', 'Isaiah', 'Jeremiah', 'Lamentations', 'Ezekiel', 'Daniel', 'Hosea', 'Joel',
    'Amos', 'Obadiah', 'Jonah', 'Micah', 'Nahum', 'Habakkuk', 'Zephaniah', 'Haggai', 'Zechariah', 'Malachi',
    'Matthew', 'Mark', 'Luke', 'John', 'Acts', 'Romans', '1 Corinthians', '2 Corinthians', 'Galatians', 'Ephesians',
    'Philippians', 'Colossians', '1 Thessalonians', '2 Thessalonians', '1 Timothy', '2 Timothy', 'Titus', 'Philemon',
    'Hebrews', 'James', '1 Peter', '2 Peter', '1 John', '2 John', '3 John', 'Jude', 'Revelation'
  ]
}

const byBook = names => Object.fromEntries(names.map((name, index) => [index + 1, name]))
const BOOK_NAMES = {pl: byBook(NAMES.pl), en: byBook(NAMES.en)}

// Kody przekładów do selecta: {1: 'EIB', 2: 'UBG', ...}.
export const BIBLE_CODES = Object.fromEntries(Object.entries(BIBLES).map(([bible, {code}]) => [bible, code]))

// Zwraca nazwy ksiąg w języku danego przekładu: {1: 'Rodzaju', ...} albo {1: 'Genesis', ...}.
export const bookNames = bible => BOOK_NAMES[BIBLES[bible]?.language ?? 'pl']
